import React, { useState } from 'react'
import { ATTACHMENT_TYPE } from 'util/documentUtils'
import { replaceNewLine } from 'util/postUtils'
import { useEffect } from 'react'
import parse from 'html-react-parser'
import { getCopyright } from 'util/documentUtils'

export default function DisplayLyrics({ song }) {

  const [lyrics, setLyrics] = useState()


  useEffect(() => {
    const getLyrics = () => {
      let jsx
      const { attachments } = song
      if (attachments) {
        console.log('DisplayLyrics attachments', attachments)
        const lyrics = attachments.find(at =>
          at.attachmentType === ATTACHMENT_TYPE.LYRICS
          ||
          at.attachmentType === ATTACHMENT_TYPE.SCRIPT
        )
        if (lyrics) {
          const { attachmentContent } = lyrics
          jsx = parse(replaceNewLine(attachmentContent))
          setLyrics(jsx)
        }
      }
      return jsx
    }
    getLyrics()
  }, [song])
  return (
    <div>
      <span style={{ whiteSpace: 'pre-wrap' }}>{lyrics}</span>
      <div style={{
        display: 'flex', justifyContent: 'center', width: '100%',
        fontStyle: 'italic', borderTop: '0.5px solid lightgray'
      }}>{getCopyright(song)}</div>
    </div>
  )
}
